// extracted by mini-css-extract-plugin
module.exports = {"brand":"layout_brand__2wxik","card":"layout_card__is7Vi","form":"layout_form__1tGfE"};